"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const __1 = require("../");
class UseSkillProcessing {
    constructor(no, sourceId, selectedId, cost, reason = __1.Reasons.NOTHING) {
        this.no = no;
        this.sourceId = sourceId;
        this.selectedId = selectedId;
        this.cost = cost;
        this.reason = reason;
    }
}
exports.UseSkillProcessing = UseSkillProcessing;
function useSkillProcessor(battle, data, step) {
    if (!(data instanceof UseSkillProcessing))
        return 0;
    const source = battle.getEntity(data.sourceId);
    const selected = battle.getEntity(data.selectedId);
    const skill = source.getSkill(data.no);
    switch (step) {
        case 1: {
            battle.log(`【${source.name}(${source.teamId})】对【${selected.name}(${selected.teamId})】使用技能【${skill.name}】`);
            if (data.cost > 0) {
                battle.actionUpdateMana(source.entityId, source.teamId, -data.cost, __1.Reasons.COST);
            }
            return 2;
        }
        case 2: {
            (skill.use && skill.use(battle, data.sourceId, data.selectedId));
            return -1;
        }
    }
    return 0;
}
exports.default = useSkillProcessor;
